export default __webpack_public_path__ + "static/media/practice-img.d6d8a8ca.png";